import type { Breakpoint } from '@mui/material';
import useTheme from '@mui/system/useTheme';
import useMediaQuery from '@mui/system/useMediaQuery';

export interface UseBreakpointsResult {
  isBreakpoint: boolean;
}

export const useBreakpoints = (defaultBreakpoint: Breakpoint = 'sm'): UseBreakpointsResult => {
  const defaultTheme = useTheme();
  const isBreakpoint = useMediaQuery(defaultTheme.breakpoints.down(defaultBreakpoint));

  return { isBreakpoint };
};
